module.exports = {
      id: "sharechat-usage",
      viewBox: "0 0 29.14 29.14",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#sharechat",
      toString: function () {
        return this.url;
      }
    }